
// Global Variables
export const sep = '/';
export const product: string = "MyBiz Quotation";
export const version: string = "1.1.1";
export const authors: string = "Devpark";
export const company: string = "Business CentriX Technology";
export const copyright: string = "© BCT";
export const licenceUrl: string = "http://www.bizcentrix.co.za";


export const configPath: string = 'assets/config/config.json';



// User Autentication Service
export const tokenKey = "token";
export const expiryKey = "expiryKeyTime";
export const userKey = "userKey";


// WEBPACK FOOTER //
// C:/Software Development/Devpark/biz-app/src/app/shared/services/global/globals.ts